import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthStore } from './auth.store';

export const complexGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (authStore.hasComplex()) {
    return true;
  }

  return router.createUrlTree(['/create-complex']);
};

export const noComplexGuard: CanActivateFn = () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  if (!authStore.hasComplex()) {
    return true;
  }

  return router.createUrlTree(['/']);
};
